import Axios from 'axios'

export const ORDERS_HISTORY_LIST = 'orders:ordersHistory'
export type ORDERS_HISTORY_LIST_TYPE = {
  type: 'orders:ordersHistory',
  payload: { orders: Object[] }
}

export const getOrdersHistory = (orders: Object[]): ORDERS_HISTORY_LIST_TYPE  => ({
  type: ORDERS_HISTORY_LIST,
  payload: { orders }
})


export const getOrdersHistoryList = (dispatch: Function) => {
  Axios.get('https://js.devexpress.com/Demos/WidgetsGallery/data/orderItems')
    .then(res => dispatch(getOrdersHistory(res.data)))
    .catch(err => console.error(err))
}


// WEBPACK FOOTER //
// ./src/actions/orders/index.js